import { OrderTypes } from '@/constants';

export const activeTab = {
  monitoringObjects: 'monitoringObjects',
  protectedProfiles: 'protectedProfiles',
};

export const queryParamsInitial = {
  page: 1,
  pageSize: 10,
  filters: [],
  sortKey: 'id',
  sortDirection: OrderTypes.Desc,
  tab: activeTab.monitoringObjects,
};

export const tabs = [
  {
    tab: 'monitoringObjects',
    title: 'Monitoring objects',
  },
  {
    tab: 'protectedProfiles',
    title: 'Protected profiles',
  },
];
